if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.minicart = document.querySelector("mini-cart");
        this.quickViewDrawer = this.closest("quick-view-drawer");
        this.eventContext = this.form.dataset.eventContext;
        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(event) {
        event.preventDefault();
        const submitButton = this.querySelector('[type="submit"]');
        if (submitButton.classList.contains("loading")) {
          return;
        }

        this.handleErrorMessage();
        this.showStockNotice("");

        submitButton.setAttribute("aria-disabled", true);
        submitButton.classList.add("loading");
        const spinner = this.querySelector(".button-overlay-spinner");
        if (spinner) spinner.classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        formData.append(
          "sections",
          this.minicart.getSectionsToRender().map((section) => section.section),
        );
        formData.append("sections_url", window.location.pathname);
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              const message = this.stockLimitMessage(response);
              const addedDespiteLimit =
                window.cartStockNotice && typeof window.cartStockNotice.isPartialAdd === "function"
                  ? window.cartStockNotice.isPartialAdd(message)
                  : /were added to your cart/i.test(message);

              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });

              /* One message, in one place. A partial add opens the mini-cart, which shows it
                 next to what was added; nothing added keeps it in the buy box, falling back to
                 the floating notice only when this form has no error slot. */
              const inMiniCart = addedDespiteLimit && !!this.minicart;
              this.showStockNotice("");
              if (inMiniCart) {
                this.handleErrorMessage(false);
              } else if (!this.handleErrorMessage(message)) {
                this.showStockNotice(message, addedDespiteLimit);
              }

              const refresh =
                this.minicart && typeof this.minicart.updateSectionContents === "function"
                  ? this.minicart.updateSectionContents()
                  : null;
              const reveal = () => {
                if (!addedDespiteLimit || !this.minicart) return;
                try {
                  this.minicart.setError(message);
                } catch (e) {}
                this.minicart.open(submitButton);
              };
              if (refresh && typeof refresh.then === "function") {
                refresh.then(reveal).catch(reveal);
              } else {
                reveal();
              }
              return;
            }
            this.showStockNotice("");

            this.minicart.renderContents(response);

            if (window.themeSettings.redirectToCart) {
              location.href = window.routes.cart_url;
            } else {
              if (this.quickViewDrawer) {
                this.quickViewDrawer.close();
                // Immediately re-add the 'drawer-open' class to avoid
                // the drawer backdrop from flashing.
                document.body.classList.add("drawer-open");
                setTimeout(() => this.minicart.open(), 200);
              } else {
                this.minicart.open(submitButton);
              }
            }

            const event = new CustomEvent("cart:item-add", {
              detail: {
                items: [response],
                context: this.eventContext,
              },
            });
            document.dispatchEvent(event);

            publish(PUB_SUB_EVENTS.cartItemAdd, {
              source: this.eventContext,
              items: [response],
            });
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            submitButton.classList.remove("loading");
            submitButton.removeAttribute("aria-disabled");
            const doneSpinner = this.querySelector(".button-overlay-spinner");
            if (doneSpinner) doneSpinner.classList.add("hidden");
          });
      }

      stockLimitMessage(response) {
        if (window.cartStockNotice && typeof window.cartStockNotice.stockLimitMessage === "function") {
          return (
            window.cartStockNotice.stockLimitMessage(response) || "Could not add this item to your cart."
          );
        }
        if (response && typeof response.description === "string" && response.description.trim()) {
          return response.description.trim();
        }
        if (
          response &&
          typeof response.message === "string" &&
          response.message.trim() &&
          response.message !== "Cart Error"
        ) {
          return response.message.trim();
        }
        return "Could not add this item to your cart.";
      }

      showStockNotice(message, partial) {
        let notice = document.querySelector("[data-atc-stock-notice]");
        if (!message) {
          if (notice) notice.hidden = true;
          return;
        }
        if (!notice) {
          notice = document.createElement("div");
          notice.setAttribute("data-atc-stock-notice", "");
          notice.className = "atc-stock-notice";
          notice.setAttribute("role", "alert");
          notice.setAttribute("aria-live", "assertive");
          document.body.appendChild(notice);
        }
        notice.textContent = message;
        notice.classList.toggle("is-partial", !!partial);
        const header = document.querySelector('[id^="shopify-section-"][class*="section-header"]');
        const headerBottom = header ? Math.round(header.getBoundingClientRect().bottom) : 64;
        notice.style.top = Math.max(headerBottom, 8) + 8 + "px";
        notice.hidden = false;
      }

      /* Returns true when the message is on screen in this form's error slot. */
      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) {
          return false;
        }

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector(".product-form-error-message-wrapper");
        if (!this.errorMessageWrapper) return false;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(".product-form-error-message");
        if (!this.errorMessage) return false;

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
        return !!errorMessage;
      }
    },
  );
}
